import { getUrlByQueryParameterObj } from '@asset/function/queryStringFunctions';
import { authAPI } from '../../core/instance';

export const getAttendancePageListApi = async (queryStringObj) => {
  let url = `/api/teachers/manage/attendance/`;

  if (queryStringObj) {
    const queryString = getUrlByQueryParameterObj('', queryStringObj);
    url += queryString;
  }

  const data = await authAPI
    .get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
  return data;
};

export const getFilteringListApi = async () => {
  const data = await authAPI
    .get(`/api/teachers/manage/attendance/filters/`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
  return data;
};

export const getStudentListByTeacherApi = async (teacherId: number | null) => {
  let url = `/api/teachers/manage/attendance/additional/`;
  if (teacherId) url += `?teacherId=${teacherId}`;
  const data = await authAPI
    .get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
  return data;
};

export const registerAttendanceStatusApi = async (reqBody) => {
  const data = await authAPI
    .post(`/api/teachers/manage/attendance/`, reqBody)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
  return data;
};

export const registerAttendanceStatusThroughModalApi = async (reqBody) => {
  const data = await authAPI
    .post(`/api/teachers/manage/attendance/additional/`, reqBody)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
  return data;
};

export const updateAttendanceStatusThroughModalApi = async (reqBody) => {
  const data = await authAPI
    .patch(`/api/teachers/manage/attendance/additional/`, reqBody)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
  return data;
};

export const sendMessageApi = async (reqBody) => {
  const data = await authAPI
    .post(`/api/teachers/manage/attendance/message/`, reqBody)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
  return data;
};

export const confirmPayAcademyFeeApi = async (reqBody) => {
  const data = await authAPI
    .patch(`/api/teachers/manage/attendance/tuition/`, reqBody)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
  return data;
};
